import { createClient } from '@supabase/supabase-js';
import type { Database } from '../types/supabase';

let supabase: ReturnType<typeof createClient<Database>> | null = null;

export function getSupabaseClient() {
  if (supabase) return supabase;

  const url = import.meta.env.VITE_SUPABASE_URL;
  const key = import.meta.env.VITE_SUPABASE_ANON_KEY;

  if (url && key) {
    supabase = createClient<Database>(url, key);
  }

  return supabase;
}

export async function isAdmin() {
  const client = getSupabaseClient();
  if (!client) return false;

  const { data: { user } } = await client.auth.getUser();
  if (!user) return false;

  return user.user_metadata?.role === 'admin';
}

export async function signInAsAdmin(email: string, password: string) {
  const client = getSupabaseClient();
  if (!client) throw new Error('No Supabase client available');

  const { data, error } = await client.auth.signInWithPassword({
    email,
    password
  });

  if (error) throw error;

  // Verify admin role
  const isUserAdmin = await isAdmin();
  if (!isUserAdmin) {
    await client.auth.signOut();
    throw new Error('Not authorized as admin');
  }
  
  return data;
}